/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import cn from 'classnames';
import LockIcon from '@material-ui/icons/Lock';
import { ReactComponent as RightArrow } from 'Assets/video-right-arrow.svg';
import { ReactComponent as LeftArrow } from 'Assets/video-left-arrow.svg';
import AlterImage from 'Assets/alter-image.png';
import { dataFetcher, endpoints } from 'Api';
import { ProfilePage, Button } from 'Components';
import { AppContext } from 'Context';
import { Pathname } from 'Routes';
import { Image } from 'semantic-ui-react';
import { Box } from '@material-ui/core';
import { CONTENT_TYPES } from 'Pages/private/profile';
import VideoAutoPlayer from './video-autoplayer';
import styles from './index.module.css';
import { TitleLabel } from './video-autoplayer/TitleLabel';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  }
};

const isTrueValue = true;
const isFalseValue = false;
const ImageGroupTitle = ({ title, marginTitle, resumeWatching, setLoading, clearResumeWatching }) => (
  <div className={styles.headingWrapper}>
    <h3
      className={cn({ [styles.imageGroupTitle]: true, [styles.marginTitle]: !marginTitle })}
    >
      {title}
    </h3>
    {
      resumeWatching ? (
        <div onClick={() => { setLoading(true); clearResumeWatching(); }} className={styles.clearAll}>Clear All</div>
      ) : null
    }
  </div>
);

const CustomRightArrow = ({ onClick }) => ((
  <RightArrow
    fontSize="large"
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right custom_arrow"
  // className="right-arrow"
  // style={{ zIndex: '1000', cursor: 'pointer', height: '40px' }}
  />
));

const CustomLeftArrow = ({ onClick }) => ((
  <LeftArrow
    onClick={onClick}
    aria-label="Go to next slide"
    className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left custom_arrow"
  // className="left-arrow"
  // style={{ zIndex: '1000', cursor: 'pointer', height: '40px', marginLeft: '-100%', background: 'none' }}
  />
));
const ImageGroup = ({ isBelow750px, center, title, videos, isGrid, searchTerm, type, albums, catG, resumeWatching, setLoading, clearResumeWatching, isPreview, handleCarousel, onShowPermissionModal, isAlbumLocked, playlistContext }) => {
  const navigate = useNavigate();
  const [isMoving, setMoving] = useState(false);
  const [showArrow, setArrows] = useState(false);
  const [showAutoPlayDiv, setAutoPlayDiv] = useState(undefined);
  let myTimeout;
  const [dimensions, setDimensions] = useState({
    // top: '0px',
    // left: '0px',
  });
  const [videoDetails, setVideoDetails] = useState({
    videoURL: '',
    thumbNail: '',
    title: '',
    subCategory: ''
  });
  const mouseOverHandler = (event, id, video_file, thumbnails, title, subCategory) => {
    const rect = event.target.getBoundingClientRect();
    setDimensions({});
    setAutoPlayDiv(id);
    setVideoDetails({ videoURL: video_file, thumbNail: thumbnails, title, subCategory });
  };

  const mouseLeaveHandler = () => {
    clearInterval(myTimeout);
    setAutoPlayDiv(undefined);
    setVideoDetails({ videoURL: '', thumbNail: '', title: '', subCategory: '' });
  };

  // Get subscription details from context
  const { subscriptionDetails } = useContext(AppContext);

  // Check video permission
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  const hasVideoPermission = () => true; // Temporarily allow all access
  /* ORIGINAL hasVideoPermission LOGIC - Replace above line to restore:
  const hasVideoPermission = (videoId) => {
    try {
      // If user has upgraded plan (is_locked = 0), allow all videos
      const isLocked = subscriptionDetails?.subscription?.is_locked;
      if (isLocked === '0' || isLocked === 0) {
        return true;
      }

      // Otherwise, check if video is in allowed list
      const allowedVideoIds = JSON.parse(localStorage.getItem('allowedVideoIds') || '[]');
      return allowedVideoIds.includes(String(videoId));
    } catch (error) {
      return false;
    }
  };
  */

  // Check album permission
  // TODO: TEMPORARY - All access enabled. Revert to original logic when needed.
  const hasAlbumPermission = () => true; // Temporarily allow all access
  /* ORIGINAL hasAlbumPermission LOGIC - Replace above line to restore:
  const hasAlbumPermission = (albumId) => {
    try {
      // If user has upgraded plan (is_locked = 0), allow all albums
      const isLocked = subscriptionDetails?.subscription?.is_locked;
      if (isLocked === '0' || isLocked === 0) {
        return true;
      }

      // Otherwise, check if album is in allowed list
      const allowedAlbumIds = JSON.parse(localStorage.getItem('allowedAlbumIds') || '[]');
      return allowedAlbumIds.includes(String(albumId));
    } catch (error) {
      return false;
    }
  };
  */

  // Handle video link click for preview mode
  const handleVideoClick = (e, videoId, videoPath) => {
    if (isPreview) {
      e.preventDefault();

      if (hasVideoPermission(videoId)) {
        // Has permission - navigate to player
        navigate(videoPath);
      } else if (onShowPermissionModal) {
        // No permission - show modal
        onShowPermissionModal();
      }
    }
  };

  useEffect(() => {
    const autoPlayElement = document?.getElementById('autoplay-div');
    const thumbnailLinkElement = document?.getElementById('thumbnail-link');
    autoPlayElement?.addEventListener('mouseleave', mouseLeaveHandler);
    return () => autoPlayElement?.removeEventListener('mouseleave', mouseLeaveHandler);
  });
  function beforeChange(index, type) {
    setMoving(true);
    if (handleCarousel) {
      handleCarousel(index, type);
    }
  }
  const carouselStyle = {
    // Define your inline styles here
    backgroundColor: 'blue',
    color: 'white',
    // Add any other CSS properties you want
  };
  return (
    <div
      className={cn({ [styles.paddingTop0]: true, [styles.imageGroup]: true, [styles.paddingTopForImage]: catG })}
    >
      {
        title
        && <ImageGroupTitle title={title} marginTitle={catG} resumeWatching={resumeWatching} setLoading={setLoading} clearResumeWatching={clearResumeWatching} />
      }
      {/* {searchTerm && <ImageGroupTitle title={`Search results for "${searchTerm}"`} />} */}
      <div className={styles.imageGroupImagesAllVideo}>
        <div className={cn({ [styles.imageGroupImagesContainer]: true, [styles.isGrid]: isGrid })}>
          {/* {searchTerm && (
            <h6 style={{ fontSize: '12pt', color: 'white' }}>
              Results for
              {' '}
              {searchTerm || '[Search]'}
            </h6>
          )} */}
          {
            albums && albums?.length > 0 && (
              <div
                onMouseEnter={() => setArrows(true)}
                onMouseLeave={() => setArrows(false)}
              >
                <Carousel
                  // swipeable={isTrueValue}
                  // draggable={isTrueValue}
                  // showDots={searchTerm ? false : isTrueValue}
                  arrows
                  slidesToSlide={3}
                  responsive={responsive}
                  ssr={isTrueValue} // means to render carousel on server-side.
                  autoPlaySpeed={1000}
                  keyBoardControl={isTrueValue}
                  // customTransition="all 20"
                  // transitionDuration={10000}
                  // arrows={showArrow}
                  containerClass="carousel-container"
                  dotListClass="custom-dot-list-style"
                  itemClass={`image-item_images ${isGrid && styles['image-item-isGrid']}`}
                  customRightArrow={<CustomRightArrow />}
                  customLeftArrow={<CustomLeftArrow />}
                  beforeChange={(p) => beforeChange(p, type)}
                  afterChange={() => setMoving(false)}
                  centerMode={isTrueValue}
                  className={styles.carousel}
                >
                  {
                    type === CONTENT_TYPES.photo_albums && (
                      isPreview ? (
                        albums?.length > 0 && albums?.map(({ id, photos, icon, photo_file, title: albumTitle, album_id }, idx) => (
                          <Box
                            className={cn(styles.hoverZoom, {
                              [styles.videoBlurred]: isAlbumLocked
                            })}
                          >
                            <Link
                              className={styles.imageGroupImageLink}
                              key={idx}
                              to={`${Pathname.getAlbumPlayerPath(album_id, id)}`}
                              onClick={(e) => {
                                if (isAlbumLocked) {
                                  e.preventDefault();
                                  if (onShowPermissionModal) {
                                    onShowPermissionModal();
                                  }
                                }
                              }}
                            >
                              <Image
                                src={photo_file}
                                className={`${styles.imageGroupImageInner} ${styles.imageGroupImageCarousel}`}
                                onError={(e) => {
                                  e.target.src = `${photo_file}?tr=orig`;
                                }}
                              />
                            </Link>
                            {/* LOCK UI DISABLED - Uncomment to restore:
                            {isAlbumLocked && (
                              <div className={styles.lockIconOverlay}>
                                <LockIcon />
                              </div>
                            )}
                            */}
                          </Box>
                        ))
                      ) : (
                        albums?.map(({ id, photos, icon, photo_file, title: albumTitle }, idx) => (
                          photos?.length > 0 && (
                            <Box
                              className={cn(styles.hoverZoom, {
                                [styles.videoBlurred]: !hasAlbumPermission(id)
                              })}
                            >
                              <Link
                                className={cn({ [styles.imageGroupImageLink]: true, [styles.albumTransition]: true })}
                                key={idx}
                                to={Pathname.getAlbumPath(id)}
                              // style={{ width: '80%' }}
                              >
                                <Image
                                  src={icon}
                                  className={`${styles.imageGroupImageInner}`}
                                  onError={(e) => {
                                    e.target.src = `${icon}?tr=orig`;
                                  }}
                                />
                                <TitleLabel title={albumTitle} />
                              </Link>
                              {/* LOCK UI DISABLED - Uncomment to restore:
                              {!hasAlbumPermission(id) && (
                                <div className={styles.lockIconOverlay}>
                                  <LockIcon />
                                </div>
                              )}
                              */}
                            </Box>
                          )
                        ))
                      )
                    )
                  }
                  {/* A blank div added to compromise the carousel bug TODO find bug */}
                  <div />
                </Carousel>
              </div>
            )
          }
          {
            videos && videos?.length > 0 && (
              <div
                onMouseEnter={() => setArrows(true)}
                onMouseLeave={() => setArrows(false)}
              >
                {
                  (isBelow750px || false)
                    ? (
                      <div className={styles.gridz}>
                        {
                          type !== CONTENT_TYPES?.photo_albums && (
                            videos?.length > 0 && videos?.map(({ id, thumbnails, draft_thumbnails, title: videoTitle, SubCategory, video_file }, idx) => (
                              <Box className={cn(styles.hoverZoom, { [styles.videoBlurred]: isPreview && !hasVideoPermission(id) })}>
                                <Link
                                  onMouseEnter={(event) => mouseOverHandler(event, id, video_file, thumbnails, videoTitle, SubCategory)}
                                  onMouseLeave={mouseLeaveHandler}
                                  onClick={(e) => handleVideoClick(e, id, isPreview ? Pathname.getPlayerPath(id, 'play') : Pathname.getVideoPath(id))}
                                  className={styles.imageGroupImageLink}
                                  key={idx}
                                  to={isPreview ? Pathname.getPlayerPath(id, 'play') : Pathname.getVideoPath(id)}
                                  state={playlistContext}
                                  id="thumbnail-link"
                                >
                                  <VideoAutoPlayer
                                    dimensions={dimensions}
                                    videoDetails={videos[idx]}
                                    thumbNail={thumbnails || AlterImage}
                                    videoID={showAutoPlayDiv}
                                    isLocked={false /* LOCK DISABLED: isPreview && !hasVideoPermission(id) */}
                                    onLockedClick={onShowPermissionModal}
                                  // autoPlay={showAutoPlayDiv === id}
                                  />
                                  <TitleLabel title={videoTitle} category={SubCategory} />

                                </Link>
                                {/* LOCK UI DISABLED - Uncomment to restore:
                                {isPreview && !hasVideoPermission(id) && (
                                  <div className={styles.lockIconOverlay}>
                                    <LockIcon />
                                  </div>
                                )}
                                */}
                              </Box>
                            ))
                          )
                        }
                      </div>
                    )
                    : (
                      <Carousel
                        // swipeable={isTrueValue}
                        // draggable={isTrueValue}
                        // showDots={searchTerm ? false : isTrueValue}
                        arrows
                        slidesToSlide={3}
                        responsive={responsive}
                        ssr={isTrueValue} // means to render carousel on server-side.
                        autoPlaySpeed={1000}
                        keyBoardControl={isTrueValue}
                        // customTransition="all 20"
                        // transitionDuration={10000}
                        // arrows={showArrow}
                        containerClass="carousel-container"
                        dotListClass="custom-dot-list-style"
                        itemClass={`image-item spclMargin ${isGrid && styles['image-item-isGrid']}`}
                        customRightArrow={<CustomRightArrow />}
                        customLeftArrow={<CustomLeftArrow />}
                        beforeChange={(p) => beforeChange(p, type)}
                        afterChange={() => setMoving(false)}
                        centerMode={isTrueValue}
                        className={center ? styles.carousels : ''}
                      >
                        {
                          type !== CONTENT_TYPES.photo_albums && (
                            videos?.length > 0 && videos?.map(({ id, thumbnails, draft_thumbnails, title: videoTitle, SubCategory, video_file }, idx) => (
                              <Box className={cn(styles.hoverZoom, { [styles.videoBlurred]: isPreview && !hasVideoPermission(id) })}>
                                <Link
                                  onMouseEnter={(event) => mouseOverHandler(event, id, video_file, thumbnails, videoTitle, SubCategory)}
                                  onMouseLeave={mouseLeaveHandler}
                                  onClick={(e) => handleVideoClick(e, id, isPreview ? Pathname.getPlayerPath(id, 'play') : Pathname.getVideoPath(id))}
                                  className={styles.imageGroupImageLink}
                                  key={idx}
                                  to={isPreview ? Pathname.getPlayerPath(id, 'play') : Pathname.getVideoPath(id)}
                                  state={playlistContext}
                                  id="thumbnail-link"
                                >
                                  <VideoAutoPlayer
                                    dimensions={dimensions}
                                    videoDetails={videos[idx]}
                                    thumbNail={thumbnails || AlterImage}
                                    videoID={showAutoPlayDiv}
                                    isLocked={false /* LOCK DISABLED: isPreview && !hasVideoPermission(id) */}
                                    onLockedClick={onShowPermissionModal}
                                  // autoPlay={showAutoPlayDiv === id}
                                  />
                                  <TitleLabel title={videoTitle} category={SubCategory} />

                                </Link>
                                {/* LOCK UI DISABLED - Uncomment to restore:
                                {isPreview && !hasVideoPermission(id) && (
                                  <div className={styles.lockIconOverlay}>
                                    <LockIcon />
                                  </div>
                                )}
                                */}
                              </Box>
                            ))
                          )
                        }
                        {/* A blank div added to compromise the carousel bug TODO find bug */}
                        <div />
                      </Carousel>
                    )
                }
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};
export default ImageGroup;
